import { useState, useEffect } from 'react';
import { Theme } from '@teo/components/icons';
import { useTranslation } from 'react-i18next';
import { ContentCardLearning } from '@teo/components';
import { sortDataLP, categoriesIcon } from '@/components/LearningPath/util';
import ThemeTree from './ThemeTree';
import { newUid } from '@/util';

const ThemeNode = ({ node, setNodes, setIsDraggingNodeDisabled }) => {
  const { t } = useTranslation();
  const [nedesLP, setNodesLP] = useState(null);
  const [refresh, setRefresh] = useState(newUid(20));
  const [nodeRoot, setNodeRoot] = useState(null);
  useEffect(() => {
    const nodedetails = node?.data?.child?.filter((el) => el?.type !== 'root');
    const itemRoot = node?.data?.child?.find((el) => el?.type === 'root');
    const sortData = sortDataLP(nodedetails || []);
    const orderData = sortData.map((el, i) => ({ ...el, order: i }));
    setNodesLP(orderData);
    setNodeRoot(itemRoot);

    setRefresh(newUid(20));
  }, [node?.data]);

  // console.log(node);

  let Icon;

  if (node?.data?.tags) {
    const learningpathTags = node?.data?.allCategories?.find(
      (el) => el?.label === node?.data?.tags.split(':')[1]
    );
    Icon = categoriesIcon(learningpathTags?.icon);
  } else {
    Icon = Theme;
  }

  return (
    <div className={`drop-container_${node?.id} flex w-full flex-col py-1`}>
      <ContentCardLearning
        icon={Icon}
        text={node?.data?.title}
        tagTitle={t('pages.learning_path.theme')}
        tagVariant="type"
        color="dark_blue"
        tagType="dark_blue"
      />
      {nedesLP?.length > 0 && (
        <div
          className="flex w-full flex-col gap-2 p-1"
          onMouseEnter={() => {
            setIsDraggingNodeDisabled(true);
            node?.data?.setIsDraggingDisabled(true);
          }}
          onMouseLeave={() => {
            setIsDraggingNodeDisabled(false);
            node?.data?.setIsDraggingDisabled(false);
          }}
        >
          <ThemeTree
            key={refresh}
            nedesLP={nedesLP}
            nodeRoot={nodeRoot}
            node={node}
            setNodes={setNodes}
          />
        </div>
      )}
    </div>
  );
};

export default ThemeNode;
